module.exports = __webpack_public_path__ + "img/crazy_love_week.4efa3333.jpg";